module.exports = __webpack_public_path__ + "static/media/roboto-v20-latin-500.020c97dc.woff2";